import { MapPinIcon } from '@heroicons/react/24/solid';
import type { SocialPost } from './types';
import type { ClubTheme } from './themes';

interface PinnedBannerProps {
  posts: SocialPost[];
  theme: ClubTheme;
  onSelect?: (postId: string) => void;
}

export default function PinnedBanner({ posts, theme, onSelect }: PinnedBannerProps) {
  if (posts.length === 0) return null;

  return (
    <div
      className="rounded-2xl p-3"
      style={{
        backgroundColor: `${theme.colors.primary}08`,
        border: `1px solid ${theme.colors.primary}30`,
      }}
    >
      <div className="mb-2 flex items-center gap-1.5">
        <MapPinIcon className="h-3.5 w-3.5" style={{ color: theme.colors.primary }} />
        <span
          className="text-[10px] font-bold uppercase tracking-widest"
          style={{ color: theme.colors.primary }}
        >
          Pinned
        </span>
      </div>

      <div className="space-y-2">
        {posts.map((post) => (
          <button
            key={post.id}
            type="button"
            onClick={() => onSelect?.(post.id)}
            className="block w-full rounded-lg p-2 text-left transition-colors hover:opacity-80"
            style={{ backgroundColor: `${theme.colors.surface}80` }}
          >
            <div className="flex items-center gap-2">
              <span className="text-xs font-semibold truncate" style={{ color: theme.colors.text }}>
                {post.author_type === 'system' ? theme.name : post.author?.full_name || 'Unknown'}
              </span>
              {post.channel && (
                <span className="text-[10px]" style={{ color: theme.colors.muted }}>
                  in {post.channel.name}
                </span>
              )}
            </div>
            {post.body && (
              <p
                className="mt-0.5 text-xs truncate"
                style={{ color: theme.colors.muted }}
              >
                {post.body.length > 120 ? `${post.body.slice(0, 117)}...` : post.body}
              </p>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
